module.exports = __webpack_public_path__ + "static/product-ac30-red-e8371dd2387bb583cd6f7427712db8c6.png";